/* unplugin-vue-components disabled */import script from "./SubMenus.vue?vue&type=script&setup=true&name=SubMenus&lang=ts"
export * from "./SubMenus.vue?vue&type=script&setup=true&name=SubMenus&lang=ts"

import "./SubMenus.vue?vue&type=style&index=0&id=48123a27&lang=less"

const __exports__ = script;

export default __exports__